import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=a04e3744&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=a04e3744&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04e3744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a04e3744')) {
      api.createRecord('a04e3744', component.options)
    } else {
      api.reload('a04e3744', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=a04e3744&scoped=true", function () {
      api.rerender('a04e3744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/contract/Create.vue"
export default component.exports